import { CourseStateType } from 'enum/course-state.enum'
import { CourseStateBadge } from 'components/reusables/states'

interface CourseStateProps {
  state: CourseStateType
}

export const CourseState = ({ state }: CourseStateProps) => (
  <CourseStateBadge state={state} />
)

export default CourseState
